import { bigWins } from '../../../mocks/bigWins';

export default function BigWinsSection() {
  return (
    <section className="py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 animate-on-scroll opacity-0">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">История крупных выигрышей</h2>
          <p className="text-gray-400">Реальные победы игроков в live-казино</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {bigWins.map((win, index) => (
            <div 
              key={win.id} 
              className="bg-gradient-to-br from-[#242429] to-[#1a1a1f] rounded-2xl p-6 border-2 border-[#d4af37] hover:shadow-2xl hover:shadow-[#d4af37]/30 transition-all duration-300 hover:scale-105 animate-on-scroll opacity-0"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="flex items-center justify-between mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-[#d4af37] to-[#f4d03f] rounded-full flex items-center justify-center">
                  <i className="ri-trophy-line text-2xl text-black"></i>
                </div>
                <span className="bg-[#2ecc71] text-black px-3 py-1 rounded-full text-sm font-bold">
                  {win.multiplier}
                </span>
              </div>

              <div className="mb-4">
                <div className="text-4xl font-bold text-[#d4af37] mb-2">{win.amount}</div>
                <div className="text-gray-400 text-sm">Выигрыш</div>
              </div>

              <div className="space-y-2 mb-4 pb-4 border-b border-gray-700">
                <div className="flex items-center gap-2">
                  <i className="ri-user-line text-gray-500"></i>
                  <span className="text-gray-300">{win.player}</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-building-line text-gray-500"></i>
                  <span className="text-gray-300">{win.casino}</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-gamepad-line text-gray-500"></i>
                  <span className="text-gray-300">{win.game}</span>
                </div>
              </div>

              <div className="flex justify-between items-center text-sm">
                <span className="text-gray-500">Ставка: {win.bet}</span>
                <span className="text-gray-500">{win.date}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-[#d4af37]/10 to-[#f4d03f]/10 rounded-2xl p-8 text-center border border-[#d4af37]/30 animate-on-scroll opacity-0">
          <i className="ri-information-line text-4xl text-[#d4af37] mb-4 block"></i>
          <h3 className="text-2xl font-bold mb-3">Ваш выигрыш может быть следующим!</h3>
          <p className="text-gray-300 mb-6">Все выигрыши реальны и подтверждены. Играйте ответственно и удача улыбнется вам!</p>
          <a 
            href="#rating" 
            className="inline-block bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-black font-bold py-3 px-8 rounded-full hover:shadow-lg hover:shadow-[#d4af37]/50 transition-all duration-300 whitespace-nowrap"
          >
            Начать играть
          </a>
        </div>
      </div>
    </section>
  );
}